import axios from 'api/axios-configure'
import { Grid } from '@mui/material'
import { AlertBanner, AlertBannerText, Button, Checkbox, TextField } from 'monday-ui-react-core'
import React, { useContext, useEffect, useState } from 'react'

import { isValidEmail } from 'utils/commonUtils'
import { ArrowLeft } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { StatementContext } from 'utils/context/StatementsContext'


const STRING_ONLY = /^[a-zA-Z\-_ ]+$/

const UserAccountForm = () => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [emailNotifications, setEmailNotifications] = useState(false)
    const [displayBanner, setDisplayBanner] = useState(false)
    const [bannerMessage, setBannerMessage] = useState('')
    const [bannerStyle, setBannerStyle] = useState('positive')
    const [isLoading, setIsLoading] = useState(true)
    const [disableSave, setDisableSave] = useState(false)
    const { getUserPermissionsSummary } = useContext(StatementContext)

    const validateStringOnly = (field) => !STRING_ONLY.test(field)

    const clearBanner = () => {
        setDisplayBanner(false)
        setBannerMessage('')
        setBannerStyle('positive')
    }

    const displayErrorMessage = (message) => {
        setBannerMessage(message)
        setBannerStyle('negative')
        setDisplayBanner(true)
    }

    const displaySuccessMessage = (message) => {
        setBannerMessage(message)
        setBannerStyle('positive')
        setDisplayBanner(true)
    }

    useEffect(() => {
        if (validateStringOnly(firstName) || validateStringOnly(lastName)) {
            setDisableSave(true)
        } else {
            setDisableSave(false)
        }
    }, [firstName, lastName, phone])

    useEffect(() => {
        setIsLoading(true)
        clearBanner()
        getUserPermissionsSummary()
        axios
            .get('GetUser')
            .then(response => {
                if (response.status != 200) {
                    displayErrorMessage('There was an error retrieving user information.')
                    return;
                }
                const user = response.data
                setFirstName(user.name)
                setLastName(user.lastName)
                setPhone(user.phoneNumber)
                setEmail(user.email)
                setEmailNotifications(user.notifications)
            })
            .catch(err => {
                console.error(err)
                displayErrorMessage('There was an error retrieving user information.')
            })
            .finally(() => {
                setIsLoading(false)
            })
    }, [])

    const handleSave = () => {
        setIsLoading(true)
        clearBanner()
        const user = {
            name: firstName,
            lastName,
            phoneNumber: phone,
            email,
            notifications: emailNotifications
        }
        axios
            .put('UpdateUser', user)
            .then(response => {
                displaySuccessMessage('Account profile data updated successfully')
                setTimeout(() => {
                    clearBanner()
                }, 5000)
            })
            .catch(err => {
                console.error(err)
                displayErrorMessage('There was an error updating user information.')
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleCancel = () => {}
    return (
        <>
            <div className="mx-2 form-content">
            {
                !isLoading ? (
                    <>
                        <Grid container spacing={2} className="">
                            <Grid item xs={12} style={{paddingTop: '0px'}}>
                                <Link
                                    className="d-flex align-items-center"
                                    to="/dashboard"
                                >
                                    <ArrowLeft size={13} />
                                    <span className="ml-2"> Back</span>
                                </Link>
                            </Grid>
                            <Grid item xs={12}>
                                <h2>User Account</h2>
                            </Grid>
                            
                            {displayBanner && (
                                <Grid item xs={12}>
                                    <AlertBanner backgroundColor={bannerStyle} isCloseHidden>
                                        <AlertBannerText text={bannerMessage} />
                                    </AlertBanner>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <TextField
                                    id="email"
                                    value={email}
                                    onChange={(event) => setEmail(event)}
                                    title={
                                        <>
                                            Email
                                        </>
                                    }
                                    placeholder="Enter your email"
                                    size={TextField.sizes.SMALL}
                                    validation={{
                                        status:
                                            email == ''
                                                ? ''
                                                : !isValidEmail(email)
                                                ? 'error'
                                                : 'success',
                                        text:
                                            email == ''
                                                ? ''
                                                : !isValidEmail(email) && email.length
                                                ? 'Please enter a valid email address.'
                                                : '',
                                    }}
                                    maxLength={128}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="first-name"
                                    value={firstName}
                                    onChange={(event) => setFirstName(event)}
                                    title={
                                        <>
                                            First Name<b style={{ color: 'red' }}>*</b>
                                        </>
                                    }
                                    placeholder="Enter your first name"
                                    size={TextField.sizes.SMALL}
                                    validation={{
                                        status:
                                            firstName == ''
                                                ? ''
                                                : validateStringOnly(firstName)
                                                ? 'error'
                                                : 'success',
                                        text:
                                            firstName == ''
                                                ? ''
                                                : validateStringOnly(firstName)
                                                ? 'Please enter a valid First Name'
                                                : '',
                                    }}
                                    maxLength={128} //TBD: DB
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="last-name"
                                    value={lastName}
                                    onChange={(event) => setLastName(event)}
                                    title={
                                        <>
                                            Last Name<b style={{ color: 'red' }}>*</b>
                                        </>
                                    }
                                    placeholder="Enter your last name"
                                    size={TextField.sizes.SMALL}
                                    validation={{
                                        status:
                                            lastName == ''
                                                ? ''
                                                : validateStringOnly(lastName)
                                                ? 'error'
                                                : 'success',
                                        text:
                                            lastName == ''
                                                ? ''
                                                : validateStringOnly(lastName)
                                                ? 'Please enter a valid Last Name'
                                                : '',
                                    }}
                                    maxLength={128} //TBD: DB
                                    requiredAsterisk
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="phone"
                                    value={phone}
                                    onChange={(event) => setPhone(event)}
                                    title="Phone"
                                    placeholder="Enter your phone number"
                                    size={TextField.sizes.SMALL}
                                    validation={{
                                        status:
                                            phone == ''
                                                ? ''
                                                : !validateStringOnly(email)
                                                ? 'error'
                                                : 'success',
                                        text:
                                            phone == ''
                                                ? ''
                                                : !validateStringOnly(email)
                                                ? 'Please enter a valid phone number.'
                                                : '',
                                    }}
                                    maxLength={128}
                                />
                            </Grid>
                            <Grid className="d-flex align-items-center" item xs={12}>
                                <Checkbox
                                    checked={emailNotifications}
                                    onChange={(event) =>
                                        setEmailNotifications(event.target.checked)
                                    }
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <p>
                                    Enable email notifications for new statements or
                                    information.
                                </p>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            className="mt-3"
                        >
                            {/* <Grid item mr={2}>
                                <Button
                                    size={Button.sizes.SMALL}
                                    type={Button.types.BUTTON}
                                    onClick={handleCancel}
                                    className="cancel"
                                >
                                    Cancel
                                </Button>
                            </Grid> */}
                            <Grid item>
                                <Button
                                    size={Button.sizes.SMALL}
                                    type={Button.types.BUTTON}
                                    className="create-account"
                                    onClick={handleSave}
                                    disabled={disableSave}
                                >
                                    Save Changes
                                </Button>
                            </Grid>
                            
                        </Grid>
                    </>
                ) : (
                    <Grid container spacing={2} className="">
                        <Grid item xs={12}>
                            <LoadingSpinner/>
                        </Grid>
                    </Grid>
                )
            }
            </div>
        </>
    )
}
export default UserAccountForm
